
import React from "react";
import { Separator } from "@/components/ui/separator";
import InternalRecipientsGroup from "./form/InternalRecipientsGroup";
import { NotificationProductData } from "@/types/notifications";

interface NotificationRecipientSelectProps {
  internalRecipients: {
    group1: boolean;
    group2: boolean;
  };
  products: NotificationProductData[];
  onInternalCheckboxChange: (group: 'group1' | 'group2') => void;
  onProductsChange: (products: NotificationProductData[]) => void;
}

const NotificationRecipientSelect = ({
  internalRecipients,
  products,
  onInternalCheckboxChange,
  onProductsChange
}: NotificationRecipientSelectProps) => {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-medium mb-2">Ontvangers</h3>
        <div className="space-y-4">
          <InternalRecipientsGroup 
            internalRecipients={internalRecipients}
            products={products}
            onInternalCheckboxChange={onInternalCheckboxChange}
            onProductsChange={onProductsChange}
          />
          <Separator />
        </div>
      </div>
    </div>
  );
};

export default NotificationRecipientSelect;
